export default {
    'name': 'telegram-s',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path d=\'M21.5 4.10223L18.4946 19.7923C18.4946 19.7923 18.0741 20.8801 16.9189 20.3584L9.98458 14.8526L9.95242 14.8364C10.8891 13.9654 18.1524 7.20266 18.4698 6.89612C18.9613 6.42136 18.6562 6.13873 18.0856 6.49736L7.35679 13.553L3.21764 12.1108C3.21764 12.1108 2.56626 11.8708 2.50359 11.3491C2.4401 10.8265 3.23908 10.5439 3.23908 10.5439L20.1131 3.68895C20.1131 3.68895 21.5 3.05793 21.5 4.10223Z\' fill=\'#006CFD\'/>'
}
